'use strict';

define('components/offers/offer-detail-ajax',[
  'jquery',
  'lib/util/langFromUrl',
  'lib/util/tda.config',
  'lib/services/offers-service',
  'lib/transforms/offers.tmpl.common',
  'lib/transforms/offers.tmpl.detail',
  'lib/util/zip',
  'lib/getParameterByName',
  'features/ctas/index',
  'txt!./offer.detail.hbs',
  'txt!tmpl/ctas.hbs',
  'lib/page-cache',
  './offer.additional.inv',
  'features/recentVehicles',
  'lib/transforms/tools.dcr.ctas',
  'features/favorites',
  'lib/analytics/blocks/index',
  'lib/analytics/context.add',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'inpageHeadline',
  'lib/tda/kac',
  'dealerLiveChat',
  'cookies',

  // side effect includes
  'Handlebars',
  'lib/helpers/ifCond', // used by offer-details-template
  'lib/helpers/toJSON', // used by offer-details-template
  'lib/helpers/if_eq',
  'lib/loader/series',
  'lib/transforms/series.mapByCode'
], function (
  $,
  langFromUrl,
  tdaConfig,
  offersFactory,
  xformOfferCommon,
  xformOfferDetail,
  zip,
  paramByName,
  ctas,
  txtTemplate,
  txtCtas,
  PageCache,
  addInv,
  recentVehicles,
  ctaXform,
  favorites,
  blocks,
  anAddContext,
  anPageLoad,
  anClicks,
  inpageHeadline,
  kac,
  dealerLiveChat,
  cookies
) {
  var offersService = offersFactory(tdaConfig.offers.r2_api_key);
  var __tmplDetail = Handlebars.compile(txtTemplate);
  var __tmplCtas = Handlebars.compile(txtCtas);
  var __isReview = window.location.pathname.indexOf('review-offers') > -1;
  var __effectiveDate = paramByName('effectiveDate');
  var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';

  var offerDetail = {
    init: function (el, config) {
      var self = this;
      self._el = el;
      self._config = config;
      self.$el = $(el);
      self.offerid = paramByName('offerid');
      self.i18n = config.i18n;
      self.params = config.params;
      self.ctas = ctaXform(config.params.ctas);
      self.offerIdPresent();
      self.getOffer();
      Handlebars.registerPartial('ctasDetail', __tmplCtas({ ctas: self.ctas }));

      if (__isReview && __effectiveDate) {
        self.drawEffectiveDate();
        self.filterEvents();
        self.filter = { offerType: '', series: '' };
        PageCache.await('series.map')
          .then(function (seriesMap) {
            self.drawSeriesFilters(seriesMap);
          })
          .catch(function (err) { console.log('err in seriesMap page cache: ', err); }); // eslint-disable-line no-console
      }
    },

    // just handle with new Err
    offerIdPresent: function offerIdPresent() {
      try {
        if (!this.offerid && !__isReview) {
          this.throwErrors();
        }
      } catch (err) {
        this.handleErrors(err);
      }
    },

    getOffer: function () {
      var self = this;
      var cacheId;
      var request = {
        tdaCode: tdaConfig.tda.code,
        zipCode: zip.getCookiedDefaultFallback(),
        offerId: self.offerid,
        lang: langFromUrl()
      };
      cacheId = 'offer.results.' + self.offerid;

      if (__isReview && __effectiveDate) {
        delete request.offerId;
        request.effectiveDate = __effectiveDate;
        request.pageSize = 999;
        cacheId = 'offer.results.' + __effectiveDate;
      }

      self.cacheId = cacheId;
      self.requestOffer(request); // sets the pageCache promise

      // Awaits the pageCache promise, xforms it and draws it
      PageCache.await(cacheId)
        .then(function (res) {
          if (!res.containsOffers) {
            self.throwErrors(res.error);
          }
          return xformOfferCommon(res.offerBundle.offers);
        })
        .then(function (offersCommon) {
          var offersForDetail = xformOfferDetail(offersCommon);
          // stash the xformed results in PageCache, for use on review-offers
          PageCache.set('offer.results.xformedForReviewPage', offersForDetail);
          self.drawOfferDetail(offersForDetail);
        })
        .catch(function (err) {
          self.handleErrors(err);
        });
    },

    requestOffer: function (request) {
      var self = this;
      if (!PageCache.hasOrPending(self.cacheId)) {
        if (__isReview && __effectiveDate) {
          PageCache.maybeSet(self.cacheId, offersService.offers().all(request));
        } else {
          PageCache.maybeSet(self.cacheId, offersService.offers().byOfferId(request));
        }
      }
    },

    throwErrors: function throwErr(err) {
      if (err && err[0] === 'Mismatch zip and tda code entered.') {
        throw new Error('zip_mismatch');
      }
      throw new Error('no_offers');
    },

    handleErrors: function handleErr(err) {
      var self = this;
      var rootUrl = '/' + tdaConfig.site.context_url;
      console.error('err: ', err.name, err.message); // eslint-disable-line no-console
      // TODO: prompt for zip mismatch without leaving offer-details
      // until we do that, get zip mistmatch prompt by moving user to /offers/
      if (err.message === 'zip_mismatch') {
        window.location.replace(rootUrl + '/offers/');
      }
      if (err.message === 'no_offers') {
        window.location.replace(rootUrl + '/suggested-offers/?offerid=' + self.offerid);
      }
    },

    drawSeriesFilters: function (seriesMap) {
      var $el = $('select#seriesSelect');
      Object.keys(seriesMap).forEach(function (key) {
        $el.append('<option value="' + key + '">' + seriesMap[key].series_display_name + '</option>');
      });
      $el.dropkick('refresh');
    },

    filterOffers: function (filter) {
      var builtFilter = $.extend(this.filter, filter);
      var filteredOffers = PageCache.get('offer.results.xformedForReviewPage');
      this.filter = builtFilter;

      if (builtFilter.offerType) {
        filteredOffers = filteredOffers.filter(function (offer) {
          return offer.offerType === builtFilter.offerType;
        });
      }
      if (builtFilter.series) {
        filteredOffers = filteredOffers.filter(function (offer) {
          return offer.model.code === builtFilter.series;
        });
      }
      this.$el.empty();
      this.drawOfferDetail(filteredOffers);
    },

    drawOfferDetail: function (offerArr) {
      var self = this;
      var context = {
        i18n: self.i18n,
        params: self.params
      };
      self.currentOffer = offerArr[0];

      offerArr.forEach(function (offer) {
        context.offer = offer;
        self.$el.append(__tmplDetail(context));
        console.log('CTX for offer detail HBS:', context); // eslint-disable-line no-console

        var $ctaScope = $('.js-ctas-' + offer.id);
        ctas.compare(offer.model.year, offer.model.code, $ctaScope);
        ctas.raq(offer.id, $ctaScope);
        ctas.inventory({
          series: offer.model.code,
          grade: offer.model.trimName,
          year: offer.model.year
        }, $('.js-ctas-' + offer.id));
        ctas.dealBuilder(offer.model.year, offer.model.code, $ctaScope);
        ctas.offers(offer.model.code, $ctaScope);

        // BAT-2701 live-chat CTAs
        var $clickToChatCta = $("a[data-destination='live-chat']", self.$el);
        var providerId = tdaConfig.chat.provider_id;
        if ($clickToChatCta.length && providerId) {
          if (tdaConfig.tda.code === 'KAC10') {
            $clickToChatCta.addClass('etsChatButton');
            $clickToChatCta.attr('data-destination', 'live-chat-kac');
            kac.dealerChat(); // BAT-2915 KAC only Chat w/Dealer CTAs
          } else {
            dealerLiveChat.init(providerId);
          }
        }
      });

      recentVehicles.saveVehicle({
        year: self.currentOffer.model.year,
        series: self.currentOffer.model.code,
        trim: self.currentOffer.model.trimName || '',
        trimCode: self.currentOffer.data.trimCodeString
      });

      ctas.dealerSite(self.$el);
      self.onFeaturesDrawn();
      self.disclaimerEvents();
      inpageHeadline.init();
      self.favListeners();
      self.drawInventory();
      self.pageLoadEvent();
    },

    // BAT-3490:  if the TDA has opted to show any or all disclaimers in Footer...
    onFeaturesDrawn: function () {
      var self = this;
      var ddp = self.params.DisclaimerPosition === 'Footer';
      var addp = self.params.AdditionalDisclaimerPosition === 'Footer';
      var rdp = self.params.RestrictionsPosition === 'Footer';
      var ardp = self.params.AdditionalRestrictionsPosition === 'Footer';

      if (self.params.expandedDisclaimersDisplay === 'Yes') {
        $('.offer-image-disclaimer', self.$el).addClass('active');
      }

      if (ddp || addp || rdp || ardp) {
        $('#main-wrapper-row').append('<div class="container footer-disclaimers"></div>');
        var disclaimerTitle = $('#disclaim-cta').clone(true);
        $('.footer-disclaimers').append(disclaimerTitle);
        var disclaimerExpander = $('#disclaimer-expander').clone(true);
        if (disclaimerExpander && disclaimerExpander.hasClass('dark-disclaimer-expander')) {
          disclaimerExpander.removeClass('dark-disclaimer-expander').addClass('dark-disclaimer-expander-footer');
        } else {
          disclaimerExpander.removeClass('disclaimer-expander').addClass('disclaimer-expander-footer');
        }
        $('.footer-disclaimers').find('.disclaim-cta').addClass('disclaim-cta-footer').removeClass('disclaim-cta');
        $('.footer-disclaimers').append(disclaimerExpander);

        if (ddp) {
          var ddpClone = $('#disclaimer-display').contents();
          $('.footer-disclaimers').append(ddpClone);
        }
        if (addp) {
          var addpClone = $('#additional-disclaimer-display').contents();
          $('.footer-disclaimers').append(addpClone);
        }

        if (rdp) {
          var rdpClone = $('#restrictions-display').contents();
          $('.footer-disclaimers').append(rdpClone);
        }
        if (ardp) {
          var ardpClone = $('#additional-restrictions-display').contents();
          $('.footer-disclaimers').append(ardpClone);
        }
        if (ddp && addp && rdp && ardp) {
          // REMOVE THE DISCLAIMER LABEL AND TOGGLE.

          // BAT-3524 - since adding dark-disclaimers, need
          // to replace the remove function with some vanilla
          // js for better browser compatibility
          if ($('#disclaim-cta').length) {
            var disclaimCta = document.getElementById('disclaim-cta');
            // the <span> element here has no children, [0] should be okay
            disclaimCta.removeChild(disclaimCta.childNodes[0]);
          }
          if ($('#disclaimer-expander').length) {
            var disclaimExpander = document.getElementById('disclaimer-expander');
            // this div has (at least) two children, so loop through and remove
            while (disclaimExpander.firstChild) {
              disclaimExpander.removeChild(disclaimExpander.firstChild);
            }
          }
        }
      }
    },

    pageLoadEvent: function () {
      var $scope = this.$el;
      if (__isReview) {
        return;
      }
      // 1) add blocks to parent context
      // updates node provided via first arg, with a data-ctx attr
      anAddContext(
        $scope,
        blocks.offerBlock(this.currentOffer),
        blocks.sectionBlock('Offer Overview')
      );

      // 2) trigger pageLoads with any additional blocks
      anPageLoad(
        $scope, // maximumParent
        blocks.keyMetrics('km-offers-detail')
      );
      anClicks($scope);
    },

    drawInventory: function () {
      if (this.params.SmartInventoryDisplay === 'Yes') {
        addInv.draw(this.currentOffer);
      }
    },

    drawEffectiveDate: function () {
      var dateArr = __effectiveDate.split('-');
      var headline = new Date(dateArr[1] + '-' + dateArr[2] + '-' + dateArr[0]).toDateString();
      $('.ro-effective-date').text('Period: ' + headline);
    },

    filterEvents: function () {
      var self = this;
      $('select#offerTypeSelect').change(function () {
        self.filterOffers({ offerType: $(this).val() });
      });

      $('select#seriesSelect').change(function () {
        self.filterOffers({ series: $(this).val() });
      });

      $('#offerTypeSelect').dropkick({ mobile: false });
      $('#seriesSelect').dropkick({ mobile: false });
    },

    disclaimerEvents: function () {
      $('#disclaimer-expander, #disclaim-cta').on('click', function () {
        var OID = $(this).closest('.offer-image-disclaimer');
        OID.toggleClass('active');
      });

      $('.disclaimer-expander-footer, .dark-disclaimer-expander-footer, .disclaim-cta-footer, .dark-disclaim-cta-footer').on('click', function () {
        $('.footer-disclaimers').toggleClass('active');
      });
    },

    favListeners: function () {
      var $favButton = $('.favorite-button', this.$el);
      if (__hasRtiDealer) {
        $favButton.hide();
      } else {
        favorites.markFav($favButton);

        $favButton.on('click', function favclick(e) {
          e.preventDefault();
          favorites.addRemove($favButton);
        });

        PageCache.on('favs.store', function () {
          favorites.toggleFav($favButton);
        });
      }
    }
  };

  return offerDetail;
});

